<template>
  <div>
    <CompanySelect />
    <CompanyList v-if="user.clientType == 2"/>
    <AddNewCompany v-if="user.clientType == 2"/>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
export default {
  name: 'MyCompanies',
  components: {
    CompanySelect: () => import('./CompanySelect.vue'),
    CompanyList: () => import('./CompanyList.vue'),
    AddNewCompany: () => import('./AddNewCompany.vue'),
  },
  computed: {
    ...mapFields(['user', 'company']),
  },
}
</script>

<style></style>
